import React from 'react';

import { TableCell, TableRow } from '@occc/ui-design-system';
import { ProductCategoryFragment } from '@occc/graphql';

import { ProductCategoryTableRowActions } from './ProductCategoryTableRowActions';

interface ProductCategoriesTableRowProps {
  productCategory: ProductCategoryFragment;
  isActionColumnVisible: boolean;
  onRowClick?: (productCategory: ProductCategoryFragment) => void;
}

export const ProductCategoriesTableRow: React.FC<ProductCategoriesTableRowProps> = ({
  productCategory,
  isActionColumnVisible,
  onRowClick,
}) => {
  const { name, rank, categoryRestriction } = productCategory;

  const onClick = React.useCallback(() => {
    if (onRowClick) {
      onRowClick(productCategory);
    }
  }, [productCategory, onRowClick]);

  return (
    <TableRow onClick={onClick}>
      <TableCell>{name}</TableCell>
      <TableCell>{categoryRestriction}</TableCell>
      <TableCell>{rank}</TableCell>
      {isActionColumnVisible && (
        <TableCell padding='button' align='right'>
          <ProductCategoryTableRowActions productCategory={productCategory} />
        </TableCell>
      )}
    </TableRow>
  );
};
